import { render } from "./postProduction.vue?vue&type=template&id=3a91572c"
import script from "./postProduction.vue?vue&type=script&lang=js"
export * from "./postProduction.vue?vue&type=script&lang=js"

import "./postProduction.vue?vue&type=style&index=0&id=3a91572c&lang=css"
script.render = render

export default script